import WarmUpPage from '../views/WarmUpPage.vue';
import AccessDenied from '../views/AccessDenied.vue';
import NotFound from '../views/NotFound.vue';
import { NaModuleIdEnum } from '../enums/moduleId';
import { FeatureFlagIdEnum } from '../enums/featureFlagIds';
import { SpaMigrationFlagIdsEnum } from '../enums/spaMigrationFlagIds';
import { redirectToLegacy } from './router-business';
import ProjectTaggingMain from '../feature/ProjectTagging/ProjectTaggingMain/ProjectTaggingMain.vue';
import ProjectTaggingMainReport from '../feature/ProjectTagging/ProjectTaggingMain/ProjectTaggingMainReport/ProjectTaggingMainReport.vue';
import ProjectTaggingMainReportExport from '../feature/ProjectTagging/ProjectTaggingMain/ProjectTaggingMainReportExport/ProjectTaggingMainReportExport.vue';
import { EmployeePageAccess } from '../enums/employeePageAccess';

export default [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'announcement' },
  },
  {
    path: '/warmup',
    name: 'warmup',
    component: WarmUpPage,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: '404' },
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    component: AccessDenied,
    meta: { title: 'Access Denied | HR Hub', auth: false },
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: { title: 'Not Found | HR Hub', auth: false },
  },
  {
    path: '/route-to-v1',
    name: 'route-to-v1',
    beforeEnter: (to) => {
      redirectToLegacy(to.query.redirectTo);
    },
    meta: { title: 'Route to v1 | HR Hub', auth: false },
  },
  {
    path: '/announcement',
    name: 'announcement',
    components: {
      default: () => import('@/views/AnnouncementPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
    meta: {
      title: 'Announcement | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.announcementModule,
      featureFlagId: FeatureFlagIdEnum.announcementModule,
      breadCrumb() {
        return [
          {
            text: 'Dashboard',
            to: { name: 'route-to-v1', query: { redirectTo: 'dashboard' } },
          },
          {
            text: 'Announcements',
            to: { name: 'announcement' },
          },
        ];
      },
    },
  },
  {
    path: '/announcement/add',
    name: 'announcement-add',
    components: {
      default: () => import('../views/AnnouncementAddPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
    meta: {
      title: 'Announcement | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.announcementModule,
      featureFlagId: FeatureFlagIdEnum.announcementModule,
      breadCrumb() {
        return [
          {
            text: 'Dashboard',
            to: { name: 'route-to-v1', query: { redirectTo: 'dashboard' } },
          },
          {
            text: 'Announcements',
            to: { name: 'announcement' },
          },
          {
            text: 'Post an Announcement',
          },
        ];
      },
    },
  },
  {
    path: '/project-tagging-maintenance',
    name: 'project-tagging-maintenance',
    components: {
      default: () => import('../views/ProjectTagging.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
    meta: {
      title: 'Project Tagging | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.projectTaggingMaintenance,
      featureFlagId: FeatureFlagIdEnum.projectTagging,
    },
    children: [
      {
        path: '',
        name: 'project-tagging-maintenance-main',
        component: ProjectTaggingMain,
      },
      {
        path: '/project-tagging-maintenance/reports',
        name: 'project-tagging-maintenance-reports',
        component: ProjectTaggingMainReport,
      },
      {
        path: '/project-tagging-maintenance/reports/exportlogs',
        name: 'project-tagging-maintenance-reports-exportlogs',
        component: ProjectTaggingMainReportExport,
      },
    ],
  },
  {
    path: '/my-attendance',
    name: 'my-attendance',
    meta: {
      title: 'My Attendance | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.attendanceLogs,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.myAttendance,
    },
    components: {
      default: () => import('../views/MyAttendancePage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/attendance-report',
    name: 'attendance-report',
    meta: {
      title: 'Attendance Report | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.attendanceReport,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.attendanceReport,
    },
    components: {
      default: () => import('../views/AttendanceReportPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/job-request',
    name: 'job-request',
    meta: {
      title: 'Job Request | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.jobRequestModule,
      featureFlagId: FeatureFlagIdEnum.jobRequestModule,
    },
    components: {
      default: () => import('../views/JobRequestDashboard.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/bulk-utility',
    name: 'bulk-utility',
    meta: {
      title: 'Bulk Action Utility | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.bulkUtilityModule,
      featureFlagId: FeatureFlagIdEnum.bulkUtilityFeature,
    },
    components: {
      default: () => import('../views/BulkUtilityPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/attendance-manager',
    name: 'attendance-manager',
    meta: {
      title: 'Attendance Manager | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.attendanceManagement,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.attendanceManagement,
      featureFlagId: FeatureFlagIdEnum.attendanceManager,
    },
    components: {
      default: () => import('../views/AttendanceManagementPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/job-request-create',
    name: 'job-request-create',
    meta: {
      title: 'Job Request | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.jobRequestModule,
      featureFlagId: FeatureFlagIdEnum.jobRequestModule,
      breadCrumb() {
        return [
          {
            text: 'Job Requisition Module',
            to: { path: '/job-request' },
          },
          {
            text: 'Create Job Requisition',
          },
        ];
      },
    },
    components: {
      default: () => import('../views/JobRequestCreatePage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/chatbot-inquiry/:chatbotType',
    name: 'chatbot-inquiry',
    meta: {
      title: 'AI Help Center | HR Hub',
      auth: true,
    },
    components: {
      default: () => import('../views/ChatBotInquiry.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/employee/add',
    name: 'employee-add',
    meta: {
      title: 'Add Employee | HR Hub',
      auth: true,
    },
    components: {
      default: () => import('../views/EmployeeAddPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/employee/:systemId/salary-history',
    name: 'salary-history',
    meta: {
      title: 'Salary History | HR Hub',
      auth: true,
      employeeProfileModule: EmployeePageAccess.salary,
      moduleId: NaModuleIdEnum.employeeProfile,
      featureFlagId: FeatureFlagIdEnum.payrollSalaryHistory,
    },
    components: {
      default: () => import('../views/SalaryHistoryPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/employee/:systemId/manage-salary-details',
    name: 'manage-salary-details',
    meta: {
      title: 'Manage Salary History | HR Hub',
      auth: true,
      employeeProfileModule: EmployeePageAccess.cpi,
      moduleId: NaModuleIdEnum.employeeProfile,
      featureFlagId: FeatureFlagIdEnum.payrollSalaryHistory,
    },
    components: {
      default: () => import('../views/ManageSalaryDetailsPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/employee-profile/:systemId',
    name: 'employee-profile',
    meta: {
      title: 'Employee Profile | HR Hub',
      auth: true,
      featureFlagId: FeatureFlagIdEnum.new201,
    },
    components: {
      default: () => import('../views/EmployeeProfilePage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/profile-template-settings',
    name: 'profile-template-settings',
    meta: {
      title: 'Employee Profile Settings | HR Hub',
      auth: true,
      featureFlagId: FeatureFlagIdEnum.enableIndependent201Configuration,
      moduleId: NaModuleIdEnum.profileTemplateSettings,
    },
    components: {
      default: () => import('../views/ProfileTemplateSettingsPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/global-profile-attributes',
    name: 'global-profile-attributes',
    meta: {
      title: 'Global Profile Attributes | HR Hub',
      auth: true,
      featureFlagId: FeatureFlagIdEnum.maintenanceModule201,
      moduleId: NaModuleIdEnum.globalProfileAttributes,
    },
    components: {
      default: () => import('../views/GlobalProfileAttributesPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/certificate-of-attendance',
    name: 'certificate-of-attendance',
    meta: {
      title: 'Certificate of Attendance | HR Hub',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.certificateOfAttendance,
      moduleId: NaModuleIdEnum.coaApplication,
    },
    components: {
      default: () => import('../views/CertificateOfAttendancePage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/break-monitoring-report',
    name: 'break-monitoring-report',
    meta: {
      title: 'Break Monitoring Report | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.breakMonitoringReport,
      featureFlagId: FeatureFlagIdEnum.breakMonitoringAttendanceReport,
    },
    components: {
      default: () => import('../views/BreakMonitoringReportPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/overtime',
    name: 'overtime',
    meta: {
      title: 'Overtime | HR Hub',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.overtime,
    },
    components: {
      default: () => import('../views/MyRequestOvertime.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/leave',
    name: 'leave',
    meta: {
      title: 'Leave | HR Hub',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.leave,
    },
    components: {
      default: () => import('../views/MyRequestLeaves.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/feature-management-page', // This route is formerly known as device-management-page
    name: 'feature-management-page',
    meta: {
      title: 'Feature Management | HR Hub',
      auth: true,
      featureFlagId: FeatureFlagIdEnum.featureManagementPage,
      moduleId: NaModuleIdEnum.featureManagement,
    },
    components: {
      default: () => import('../views/DeviceManagementPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/shift-center',
    name: 'shift-center',
    meta: {
      title: 'Shift Center',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.shiftCenter,
      moduleId: NaModuleIdEnum.shiftCenter,
      enablePermission: true,
    },
    components: {
      default: () => import('../views/ShiftCenter/ShiftCenterMainPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/shift-builder',
    name: 'shift-builder',
    meta: {
      title: 'Shift Builder',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.shiftCenter,
      moduleId: NaModuleIdEnum.shiftCenter,
      enablePermission: true,
    },
    components: {
      default: () => import('../views/ShiftCenter/ShiftCenterShiftBuilderFormPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/work-location',
    name: 'work-location',
    meta: {
      title: 'Work Location | HR Hub',
      auth: true,
      moduleId: NaModuleIdEnum.location,
    },
    components: {
      default: () => import('../views/WorkLocation.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/shift-assignment',
    name: 'shift-assignment',
    meta: {
      title: 'Shift Assignment',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.shiftCenter,
      moduleId: NaModuleIdEnum.shiftCenter,
      enablePermission: true,
    },
    components: {
      default: () => import('../views/ShiftCenter/ShiftCenterAssignment.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    meta: {
      title: 'Calendar',
      auth: true,
      spaMigrationFlagId: SpaMigrationFlagIdsEnum.shiftCenter,
      moduleId: NaModuleIdEnum.calendar,
    },
    components: {
      default: () => import('../views/ShiftCenter/ShiftCenterCalendar.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/company-profile',
    name: 'company-profile',
    meta: {
      title: 'Company Profile | HR Hub',
      auth: true,
    },
    components: {
      default: () => import('../views/CompanyProfilePage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
  {
    path: '/bulk-upload',
    name: 'bulk-upload',
    meta: {
      title: 'Bulk Upload | HR Hub',
      auth: true,
      featureFlagId: FeatureFlagIdEnum.enableBulkImportPage,
      requireCountry: 'TH',
      featureFlagDeniedRoute: 'access-denied',
    },
    components: {
      default: () => import('../views/BulkUploadPage.vue'),
      navbar: () => import('../feature/Navigation/NavBar.vue'),
    },
  },
];
